import { icons } from "lucide-react";

import { ErrorProps, FormTextInput } from ".";

interface FormInputProps {
  autoFocus?: boolean;
  label: string;
  placeholder?: string;
  required?: boolean;
  errors?: ErrorProps;
  register: any;
  suffix?: keyof typeof icons;
  suffixClass?: string;
  id?: string;
  autoComplete?: string;
}
export default function FormEmailInput({
  label,
  required,
  errors,
  autoFocus,
  register,
  placeholder,
  suffix,
  suffixClass,
  id,
  autoComplete,
}: FormInputProps) {
  return (
    <FormTextInput
      id={id}
      autoComplete={autoComplete}
      label={label}
      required={required}
      errors={errors}
      autoFocus={autoFocus}
      type="email"
      register={register}
      placeholder={placeholder}
      suffix={suffix}
      suffixClass={suffixClass}
    />
  );
}
